import { render, staticRenderFns } from "./DetailsRender.vue?vue&type=template&id=7784b9df&scoped=true&"
import script from "./DetailsRender.vue?vue&type=script&lang=js&"
export * from "./DetailsRender.vue?vue&type=script&lang=js&"
import style0 from "./DetailsRender.vue?vue&type=style&index=0&id=7784b9df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7784b9df",
  null
  
)

export default component.exports